import { useState } from "react";
import { Modal } from "react-bootstrap";
import { withIntl } from "../wrappers";
import { intlShape } from "../shapes";

import Row from "./Grid/Row";
import Column from "./Grid/Column";
import { isString } from "../utils";

type OwnProps = {
  id?: string;
  show?: boolean;
  titleText?: string;
  backdropClassName?: string;
  buttonConfirmText?: string;
  buttonAltConfirmText?: string;
  buttonCancelText?: string;
  messageText?: string | React.ReactNode | React.ReactNode[];
  image?: string;
  onConfirm?: $TSFixMeFunction;
  onAltConfirm?: $TSFixMeFunction;
  onClose?: $TSFixMeFunction;
  backdrop?: string;
  intl: intlShape;
  showConfirm?: boolean;
  showCancel?: boolean;
  showAlternative?: boolean;
  secondConfirmText?: string;
  secondConfirmLabel?: string | React.ReactElement;
  children?: React.ReactNode;
  isLoading?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  show: false,
  titleText: undefined,
  buttonConfirmText: undefined,
  buttonAltConfirmText: undefined,
  buttonCancelText: undefined,
  messageText: undefined,
  image: undefined,
  showConfirm: true,
  showCancel: true,
  showAlternative: false,
  secondConfirmText: undefined,
  secondConfirmLabel: undefined,
  children: null,
};

type Props = OwnProps & typeof defaultProps;

export function ConfirmationModal({
  id,
  show,
  titleText,
  messageText,
  backdropClassName,
  buttonConfirmText,
  buttonAltConfirmText,
  buttonCancelText,
  onConfirm,
  onClose,
  onAltConfirm,
  backdrop,
  intl,
  image,
  showConfirm,
  showCancel,
  showAlternative,
  secondConfirmText,
  secondConfirmLabel,
  children,
  isLoading = false,
}: Props) {
  const [value, setValue] = useState("");
  let secondConfirmStepElement;
  let disableConfirm = false;

  const handleChange = (e: $TSFixMe) => {
    setValue(e.target.value);
  };
  const confirmText = isString(buttonConfirmText)
    ? buttonConfirmText
    : intl.formatMessage({ id: "button.confirm" });
  const alternativeText = isString(buttonAltConfirmText)
    ? buttonAltConfirmText
    : intl.formatMessage({ id: "button.alternative" });
  const cancelText = isString(buttonCancelText)
    ? buttonCancelText
    : intl.formatMessage({ id: "button.cancel" });

  if (secondConfirmText && secondConfirmLabel) {
    disableConfirm = value !== secondConfirmText;
    secondConfirmStepElement = (
      <Row>
        <Column>
          <form className="input-group margin-top" noValidate>
            <p>{secondConfirmLabel}</p>
            <input
              id="confirmation-second-step"
              data-testid="confirmation-second-step"
              className="space-before"
              type="text"
              value={value}
              onChange={handleChange}
            />
          </form>
        </Column>
      </Row>
    );
  }

  const modalHeader = (
    <Modal.Header data-testid="modal-header" closeButton>
      <Modal.Title>{titleText}</Modal.Title>
    </Modal.Header>
  );

  const modalBody = (
    <Modal.Body data-testid="modal-body">
      {image ? (
        <Row>
          <Column>
            {image && (
              <img data-testid="modal-body-image" alt="device" src={image} />
            )}
          </Column>
        </Row>
      ) : null}
      <Row>
        <Column>{messageText}</Column>
      </Row>
      {secondConfirmStepElement}
      {children}
    </Modal.Body>
  );

  const renderConfirmButton = showConfirm ? (
    <div
      className="confirmation-button"
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      data-three-buttons={showAlternative.toString()}
    >
      <button
        id="button-confirm"
        data-testid="test-button-confirm"
        type="button"
        disabled={disableConfirm || isLoading}
        className="btn btn-primary"
        onClick={onConfirm}
      >
        {confirmText}
      </button>
    </div>
  ) : null;
  const renderAltConfirmButton = showAlternative ? (
    <div
      className="confirmation-button"
      data-three-buttons={showAlternative.toString()}
    >
      <button
        id="button-alternative"
        data-testid="test-button-alternative"
        type="button"
        className="btn"
        onClick={onAltConfirm}
      >
        {alternativeText}
      </button>
    </div>
  ) : null;

  const renderCloseButton = showCancel ? (
    <div
      className="confirmation-button"
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      data-three-buttons={showAlternative.toString()}
    >
      <button
        id="button-cancel"
        data-testid="test-button-cancel"
        type="button"
        className="btn btn-default"
        onClick={onClose}
      >
        {cancelText}
      </button>
    </div>
  ) : null;

  const modalFooter = (
    <Modal.Footer data-testid="modal-footer">
      <Row>
        <Column>
          <div className="modal-btn-group">
            {renderConfirmButton}
            {renderAltConfirmButton}
            {renderCloseButton}
          </div>
        </Column>
      </Row>
    </Modal.Footer>
  );

  return (
    <Modal
      id={id}
      show={show}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      onHide={onClose}
      restoreFocus={false}
      backdropClassName={backdropClassName}
      backdrop={backdrop}
    >
      {modalHeader}
      {modalBody}
      {modalFooter}
    </Modal>
  );
}

ConfirmationModal.defaultProps = defaultProps;

export default withIntl(ConfirmationModal);
